const rankingItems = [
  { rank: 1, title: '顶流男星深夜密会神秘女子，酒店同框照曝光', heat: '987万', tag: '爆', tagColor: 'bg-primary-500' },
  { rank: 2, title: '知名网红偷税被罚数千万，直播间已停播一周', heat: '856万', tag: '热', tagColor: 'bg-accent-500' },
  { rank: 3, title: '某女团成员与前经纪公司解约内幕曝光', heat: '723万', tag: '热', tagColor: 'bg-accent-500' },
  { rank: 4, title: '综艺节目录制现场发生意外，节目组紧急回应', heat: '654万', tag: '新', tagColor: 'bg-secondary-500' },
  { rank: 5, title: '17吃瓜黑料网独家：当红小生家世背景被深挖', heat: '521万', tag: '荐', tagColor: 'bg-secondary-500' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="w-full max-w-[960px] mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <div className="w-1 h-7 md:h-8 rounded-full bg-primary-500"></div>
          <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950">
            热搜榜
          </h2>
          <span className="text-xs text-foreground-400 mt-1 whitespace-nowrap">· 实时热度追踪</span>
        </div>

        <div className="flex flex-col gap-0 rounded-xl overflow-hidden border border-background-200/70">
          {rankingItems.map((item) => (
            <div
              key={item.rank}
              className="flex items-center gap-3 md:gap-4 px-4 md:px-6 py-4 hover:bg-background-100/70 transition-colors duration-200 cursor-pointer border-b border-background-200/50 last:border-b-0"
            >
              <div className={`w-7 h-7 md:w-8 md:h-8 rounded-lg flex items-center justify-center font-bold text-sm flex-shrink-0 ${
                item.rank <= 3
                  ? 'bg-primary-500 text-background-50'
                  : 'bg-background-200 text-foreground-500'
              }`}>
                {item.rank}
              </div>

              <div className="flex-1 min-w-0">
                <h3 className="text-sm md:text-base font-medium text-foreground-800 truncate">
                  {item.title}
                </h3>
              </div>

              <span className={`px-2 py-0.5 rounded text-[10px] md:text-xs font-bold text-background-50 flex-shrink-0 whitespace-nowrap ${item.tagColor}`}>
                {item.tag}
              </span>

              <span className="text-xs text-foreground-400 flex-shrink-0 whitespace-nowrap w-14 text-right">
                {item.heat}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}